// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { fontConfig } from "@vanmeter/XDL/constants";
import IconX from "@vanmeter/XDL/Icons/IconClose";
import { buttonTransparent } from "@vanmeter/XDL/PreStyle/button";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { color, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            drawerTitle: css`
                background: ${color("common.white")};
                border-bottom: 1px solid ${color("common.border")};
                padding-bottom: 12px;
            `,
            headlineTypography: css`
                margin: 0;
            `,
            titleButton: css`
                ${buttonTransparent}
                padding: 8px;
                ${IconWrapper} {
                    color: ${color("common.ui5")};
                }
                &:hover {
                    ${IconWrapper} {
                        color: ${color("common.ui15")};
                    }
                }
            `,
            drawerBody: css`
                width: 360px;
                background: ${color("common.white")};
                box-shadow:
                    0 2px 4px 0 ${color("common.ui5", 0.5)},
                    0 -2px 0 0 ${color("secondary.main")};
                padding: 16px;
                ${xScreen("lt", "sm")} {
                    top: 0;
                    height: 100%;
                    width: 100vw;
                }
            `,
            drawerContent: css`
                overflow-x: hidden;
                background: ${color("common.white")};
                padding-top: 16px;
            `,
        },
        headlineTypographyProps: {
            forwardAs: "p",
            weight: fontConfig.weight.bold,
            color: "common.ui7",
            variant: "h4",
            css: css`
                margin-bottom: 0;
                letter-spacing: 0;
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: IconX,
            size: 14,
        },
    },
} as xBaseTheme["drawer"];
